/* eslint-disable */

import { AbilityBuilder } from "@casl/ability";
import store from "./store";
import HttpUtils from "./utils/http-common";

const userTypes = {
  admin: [
    "admin",
    "executive",
    "finance",
    "customer operations manager",
    "customer operations engineer",
    "Supply Chain".toLowerCase(),
    "technical team",
    "customer projects",
    "customer service",
    "sales executive"
  ],
  agent: ["agent", "lifestyle", "groove"],
  customer: ["customer", "alc customer", "groove customer", "iot customer"],
  sm: ["section manager"]
};

function setAccessLocal(userSession) {
  store.commit("setUser", userSession);
  //ability.update(userSession.roleType);
}

function init(acl, can) {
  // console.log({ acl });

  if (
    acl
      .map(item => userTypes.admin.includes(item.principalType.toLowerCase()))
      .includes(true)
  ) {
    can("read", "all");
    can("see", "installation");
    can("manage", "installation");
    can("manage", "allDevices");
    can("manage", "onboardingTracker");
    can("manage", "bills");
    // can("see", "maintenance");
    // can("manage", "subsmanager");
    can("am", "manager"); //subsmanager
    //can('create', ['invoice'])
    if (acl.find(x => x.principalType === userTypes.admin[0]) !== undefined) {
      can(["update", "create"], "installation");
      can("see", "proforma");
      can("see", "warnings");
      can(
        ["create", "manage"],
        ["token", "wallet", "user", "invoice", "report", "inventory"]
      );
    }
    if (acl.find(x => x.principalType === userTypes.admin[1]) !== undefined) {
      can("create", ["token", "wallet", "inventory", "invoice"]);
      can(["update", "create"], "installation");
    }
    if (acl.find(x => x.principalType === userTypes.admin[2]) !== undefined) {
      // console.log(userTypes.admin[2])
      can("am", "finance");
      can(["update", "create"], "installation");
      can("create", ["token", "wallet", "inventory", "invoice"]);
      can(
        ["create", "manage"],
        ["token", "wallet", "user", "invoice", "report", "subsmanager"]
      );
      //console.log(acl.find(x => x.principalType === userTypes.admin[3]));
    }
    if (acl.find(x => x.principalType == userTypes.admin[3]) !== undefined) {
      can("am", "manager");
      can("see", "maintenance");
      can(["update", "create"], "installation");
      can("see", "warnings");
      //console.log(acl,'Manager');
    }
    if (acl.find(x => x.principalType == userTypes.admin[4]) !== undefined) {
      can("see", "maintenance");
      can("am", "engineer");
      can("see", "warnings");
    }
    if (acl.find(x => x.principalType == userTypes.admin[5]) !== undefined) {
      can("create", "inventory");
    }
    if (acl.find(x => x.principalType == userTypes.admin[6]) !== undefined) {
      can("manage", "alarmConfig");
      can("see", "warnings");
    }
    if (acl.find(x => x.principalType == userTypes.admin[7]) !== undefined) {
      can("commission", "installation");
      can("edit", "installation");
      can("create", "customer");
      can("see", "proforma");
      can("see", "warnings");
    }
    if (acl.find(x => x.principalType == userTypes.admin[8]) !== undefined) {
      can("am", "cxTeam");
      can(["create", "manage", "edit"], ["user", "customer"]);
    }
  }

  if (
    acl.map(item => userTypes.agent.includes(item.principalType)).includes(true)
  ) {
    // can('create', ['device', 'token'])
    // console.log("agent");
    can("see", "installation");
    can("manage", ["device", "customer"]);
    can("read", [
      "device",
      "token",
      "wallet",
      "user",
      "performance",
      "notification",
      "dashboard"
    ]);
    can("create", ["device", "token", "wallet"]);
    if (acl.find(x => x.principalType === userTypes.agent[0]) !== undefined) {
    }
    if (acl.find(x => x.principalType === userTypes.agent[1]) !== undefined) {
    }
    if (acl.find(x => x.principalType === userTypes.agent[2]) !== undefined) {
    }
  }
  if (
    acl.map(item => userTypes.sm.includes(item.principalType)).includes(true)
  ) {
    can("see", "installation");
    // console.log({ sm: "item.principalType" });
    // can("create", ["token", "device", "wallet"]);
    can("manage", ["device", "mine", "my-request"]);
    can("read", [
      "device",
      "token",
      "wallet",
      "notification",
      "dashboard",
      "installation"
    ]);
    can("am", "sm");
    can("query", "history");
    can("am", "manager");
    can("see", "customerWarning");
    can("see", "billing");
  }
  if (
    acl
      .map(item => userTypes.customer.includes(item.principalType))
      .includes(true)
  ) {
    can("see", "installation");
    // console.log("customer");customer
    can("create", ["token", "device", "wallet"]);
    can("manage", ["device", "mine", "my-request", "invoice"]);
    can("read", [
      "device",
      "token",
      "wallet",
      "notification",
      "dashboard",
      "installation"
    ]);
    can("am", "customer");
    can("see", "customerWarning");
    can("see", "billing");
    if (
      acl.find(x => x.principalType === userTypes.customer[0]) !== undefined
    ) {
    }
    if (
      acl.find(x => x.principalType === userTypes.customer[1]) !== undefined
    ) {
    }
    if (
      acl.find(x => x.principalType === userTypes.customer[2]) !== undefined
    ) {
    }
    if (
      acl.find(x => x.principalType === userTypes.customer[3]) !== undefined
    ) {
      can("read", "performance");
    }
  }
}

export default AbilityBuilder.define(can => {
  const userSession = store.getters.getUserSession;

  if (userSession) {
    const acl = userSession.role_mappings;

    if (!acl) {
      // Switch to use http1 first, but handle 401 errors gracefully.
      const HTTP1 = HttpUtils.instance;
      HTTP1.get(
        `/users/${userSession.id}?filter[include][role_mappings]/?${Date.now()}`
      )
        .then(userResponse => {
          if (userResponse.status === 200) {
            // Success!
            const saveRole = [
              { subject: userResponse.data.roleType, actions: "all" }
            ];
            userResponse.data.token = token;
            userResponse.data.roleType = saveRole;
            setAccessLocal(userResponse.data);
            init(userResponse.data.role_mappings, can);
          } else if (userResponse.status === 401) {
            // Fall back to HTTP, but don't initialize abilities until we have a successful response.
            const HTTP = HttpUtils.FASTHTTP;

            HTTP.get("/auth/user", {}).then(fallbackUserResponse => {
              if (fallbackUserResponse.status === 200) {
                const saveRole = [
                  {
                    subject: fallbackUserResponse.data.roletype,
                    actions: "all"
                  }
                ];
                fallbackUserResponse.data.token = token;
                fallbackUserResponse.data.roleType = saveRole;
                setAccessLocal(fallbackUserResponse.data);
                init(fallbackUserResponse.data.role_mappings, can);
              } else {
                // Handle the fallback user response error.
                console.error(
                  "Fallback user response error: ",
                  fallbackUserResponse
                );
              }
            });
          } else {
            // Handle the initial user response error.
            console.error("Initial user response error: ", userResponse);
          }
        })
        .catch(error => {
          // Handle any unexpected errors during the HTTP1 request.
          console.error("Unexpected error during HTTP1 request: ", error);
        });
    } else {
      // We already have ACL data, so initialize abilities now.
      init(acl, can);
    }
  } else {
    // User is not logged in, so initialize abilities with anonymous permissions.
    can("all", "anon");
  }
});

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }
  return item.__type;
}

// can('create', 'invoice')

// can('read', 'token')

// can('manage', 'inventory')

// can('manage', 'component')

// can('update', 'inventory')

// can('delete', 'inventory')



// WEBPACK FOOTER //
// ./src/ability.js